module.exports = __webpack_public_path__ + "img/wrap.ba95835f.svg";